<bzg-modal-header>
  <span class="bzg-modal__header">{{'BASEKNOWLEDGECATALOG.ADD_KNOWLEDGE_TITLE' | translate}}</span>
</bzg-modal-header>

<bzg-modal-content class="content">
  <bzg-input #displayNameModel="ngModel" [(ngModel)]="catalog.DisplayName" [pattern]="'^(?!\\s*$)[A-Za-z0-9 ñÑ\\s]+$'" [placeholder]="'BASEKNOWLEDGECATALOG.NAME_ARTIFACT' | translate" class="content__name margin_bottom" required (ngModelChange)="onCatalogFieldChange(displayNameModel?.invalid)">
    {{'BASEKNOWLEDGECATALOG.NAME_ARTIFACT' | translate}}
    <bzg-required-error>{{'BASEKNOWLEDGECATALOG.ERROR_NAME' | translate}}</bzg-required-error>
    <bzg-pattern-error>{{'BASEKNOWLEDGECATALOG.ERROR_PATTERN' | translate}}</bzg-pattern-error>
  </bzg-input>
  <bzg-textarea [(ngModel)]="catalog.Description" [placeholder]="'BASEKNOWLEDGECATALOG.DESCRIPTION_ARTIFACT' | translate" required class="content__description" (ngModelChange)="onCatalogFieldChange()">
    {{'BASEKNOWLEDGECATALOG.DESCRIPTION_ARTIFACT' | translate}}
    <bzg-required-error>{{'BASEKNOWLEDGECATALOG.ERROR_DESCRIPTION' | translate}}</bzg-required-error>
  </bzg-textarea>

  <div class="content__upload">
    <div class="content__upload-title">
      <span class="content__upload-title-files">{{'BASEKNOWLEDGECATALOG.UPLOAD_FILES' | translate}}</span>
      <span class="content__upload-title-maximum">{{ 'BASEKNOWLEDGECATALOG.MAXIMUM_FILES' | translate}}</span>
    </div>

    <div class="content__upload-button">
      <bzg-button-primary class="content__upload-button-btn" icon="icon-upload-file" iconSize="14" (click)="uploadFile()">
        {{'BASEKNOWLEDGECATALOG.BTN_UPLOAD' | translate}}
      </bzg-button-primary>
      <input #fileUpload type="file" [hidden]="true" accept=".pdf,.doc,.docx,.txt,.md,.json,.xls,.xlsx,.csv" filters=".pdf,.doc,.docx,.txt,.md,.json,.xls,.xlsx,.csv" (change)="onFilesUploaded()" multiple>
      <div class="content__upload-button-text">
        <span class="content__upload-button-text-label">{{'BASEKNOWLEDGECATALOG.UPLOAD_HERE' | translate}}</span>
        <span class="content__upload-button-text-size">{{'BASEKNOWLEDGECATALOG.UPLOAD_SIZE' | translate}}</span>
      </div>
    </div>
  </div>

  <file-artifacts-table 
    [artifacts]="catalog.KBArtifacts" 
    (removeFile)="removeFile($event)"
    (artifactChanged)="onArtifactChanged($event)">
  </file-artifacts-table>
</bzg-modal-content>

<bzg-modal-footer class="modal-catalog-footer">
  <bzg-button-secondary (click)="close()" class="bz-space--inline-m" class="btn-cancel-modal">{{'GLOBAL.CANCEL' | translate}}
  </bzg-button-secondary>
  <bzg-button-primary (click)="ok()" [disabled]="btnDisabled()">{{'GLOBAL.SAVE' | translate}}
  </bzg-button-primary>
</bzg-modal-footer>
